module.exports = __webpack_public_path__ + "img/1440.f1d3d7cf.svg";